import { storefrontCustomerApi } from '@/hooks/shopify-hooks/api/useStoreFrontCustormer';
import { b2bCustomerApi } from '@/hooks/shopify-hooks/api/useB2bCustormer';
import { shopifyConst } from '@/hooks/shopify-hooks/useShopifyConst.js';
const { c4aOAuth2State } = shopifyConst;
const c4aOAuth2StateNew = c4aOAuth2State === 'true' ? true : false;
const {  countryIsoCode } = shopifyConst;

export class CustomerData {
  constructor(isB2b) {
      this.isB2b = isB2b;
  }

  normalizeCustomerData(customer) {
      customer.email = customer?.emailAddress?.emailAddress;
      customer.phone = customer?.phoneNumber?.phoneNumber;

      if (customer?.addresses?.edges?.length) {
          customer.addresses.edges = customer.addresses.edges.map(({node: address}) => {
              return {
                  node: {
                      ...address,
                      provinceCode: address.zoneCode,
                      phone: address.phoneNumber
                  }
              }
          });
      }

      if (customer?.orders?.edges?.length) {
          customer.orders.edges = customer.orders.edges.map(({node: order}) => {
              return {
                  node: {
                      ...order,
                      orderNumber: order.number,
                      successfulFulfillments: order.fulfillments?.edges?.map(({node: fulfillment}) => {
                          return {
                              trackingInfo: fulfillment.trackingInformation
                          }
                      })
                  }
              }
          });
      }
  }

  async getCustomer(accessToken) {
      try {
        const customer = (this.isB2b || c4aOAuth2StateNew) ? await b2bCustomerApi.fetchCustomer(accessToken) : await storefrontCustomerApi.fetchCustomer(accessToken);
          if (this.isB2b) {
              this.normalizeCustomerData(customer);
          }
      
          return customer;
      } catch (e) {
          console.error(e);
      }
  }

  async updateCustomer(customerModel, accessToken, validateParams,customOptions) { // validateParams极验参数
      if (this.isB2b || c4aOAuth2StateNew) {
          if(!customerModel.email && c4aOAuth2StateNew){
            return await storefrontCustomerApi.C4AcustomerUpdatePerson(customerModel, accessToken, validateParams,customOptions);
          }
          const customer = {
              "firstName": customerModel.firstName,
              "lastName": customerModel.lastName
          }

          const response = await b2bCustomerApi.customerUpdate(customer, accessToken);

          if (response?.userErrors?.length) {
              response.customerUserErrors = response.userErrors;
          }

          if (response?.customer) {
              this.normalizeCustomerData(response.customer);
          }

          return response;
      } else {
        if (validateParams) {
            return await storefrontCustomerApi.customerUpdate(customerModel, accessToken, validateParams,customOptions);
        } else {
            return await storefrontCustomerApi.customerUpdatePerson(customerModel, accessToken, validateParams,customOptions);
        }
      }
  }


  async addBirth(customerModel, accessToken, validateParams,customOptions) { // validateParams极验参数
     return await storefrontCustomerApi.addBirthFn(customerModel, accessToken, validateParams,customOptions);
  }

// eslint-disable-next-line complexity
  async addAddress(addressModel, accessToken, isDefault) {
      if (this.isB2b) {
          const address = {
              "address1": addressModel.address1,
              "address2": addressModel.address2 || "",
              "city": addressModel.city,
              "firstName": addressModel.firstName,
              "lastName": addressModel.lastName,
              "phoneNumber": addressModel.phone || "",
              "territoryCode": countryIsoCode,
              "zip": addressModel.zip,
              "zoneCode": addressModel.province
          }

        //   const isDefault = (addressModel.default && addressModel.default === 'on');

          const response = await b2bCustomerApi.customerAddressCreate(address, isDefault || false, accessToken);

          if (response?.userErrors?.length) {
              response.customerUserErrors = response.userErrors;
          }

          return response;
      } else {
        try {
            let response
            if(c4aOAuth2StateNew) {
                const address = {
                    "address1": addressModel.address1,
                    "address2": addressModel.address2 || "",
                    "city": addressModel.city,
                    "firstName": addressModel.firstName,
                    "lastName": addressModel.lastName,
                    "phoneNumber": addressModel.phone || "",
                    "territoryCode": countryIsoCode,
                    "zip": addressModel.zip,
                    "zoneCode": addressModel.province
                }
                response = await b2bCustomerApi.customerAddressCreate(address,isDefault || false, accessToken);
            }else {
                response = await storefrontCustomerApi.customerAddressCreate(addressModel, accessToken);
            }
            if (isDefault) {
              const addressId = response?.customerAddress?.id;
              await storefrontCustomerApi.customerDefaultAddressUpdate(addressId, accessToken);
            }
            return response;
        } catch(e) {
            console.error(e);
        }
         
      }
  }
// eslint-disable-next-line complexity
  async updateAddress(addressModel, addressId, isDefault, accessToken) {
    console.log('isB2b',this.isB2b)
        if (this.isB2b) {
          const address = {
              "address1": addressModel.address1,
              "address2": addressModel.address2 || "",
              "city": addressModel.city,
              "firstName": addressModel.firstName,
              "lastName": addressModel.lastName,
              "phoneNumber": addressModel.phone || "",
              "territoryCode": countryIsoCode,
              "zip": addressModel.zip,
              "zoneCode": addressModel.province
          }

        //   if (isDefault === "on") {
        //       isDefault = true;
        //   }

          const response = await b2bCustomerApi.customerAddressUpdate(address, addressId, isDefault || false, accessToken);

          if (response?.userErrors?.length) {
              response.customerUserErrors = response.userErrors;
          }

          return response;
      } else {
        let response
          if(c4aOAuth2StateNew) {
            const address = {
                "address1": addressModel.address1,
                "address2": addressModel.address2 || "",
                "city": addressModel.city,
                "firstName": addressModel.firstName,
                "lastName": addressModel.lastName,
                "phoneNumber": addressModel.phone || "",
                "territoryCode": countryIsoCode,
                "zip": addressModel.zip,
                "zoneCode": addressModel.province
            }
            // let addressidSplit = addressId.split('?')[0]
            // console.log('addressIdaddressIdaddressId',addressidSplit)
            // const newGid = addressidSplit.replace("MailingAddress", "CustomerAddress");
            response = await b2bCustomerApi.customerAddressUpdate(address, addressId, isDefault || false, accessToken);
            }else {
            response = await storefrontCustomerApi.customerAddressUpdate(addressModel, addressId, accessToken);
            }
          if (isDefault) {
            await storefrontCustomerApi.customerDefaultAddressUpdate(addressId, accessToken);
          }
          return response;
      }
  }

  async updateDefaultAddress(addressId, accessToken) {
      if (this.isB2b) {
          return await b2bCustomerApi.customerAddressUpdate({}, addressId, true, accessToken);
      } else {
        if(c4aOAuth2StateNew){
          return await b2bCustomerApi.customerAddressUpdate({}, addressId, true, accessToken);

        }
          return await storefrontCustomerApi.customerDefaultAddressUpdate(addressId, accessToken);
      }
  }

  async deleteAddress(addressId, accessToken) {
      if (this.isB2b) {
          return await b2bCustomerApi.customerAddressDelete(addressId, accessToken);
      } else {
        if(c4aOAuth2StateNew) {
          return await b2bCustomerApi.customerAddressDelete(addressId, accessToken);
        }
          return await storefrontCustomerApi.customerAddressDelete(addressId, accessToken);
      }
  }
}